import React, {useState } from 'react'
import { BannerToolContext } from '../BannerCustomization'
import { BlockPicker} from 'react-color'
import FrameComponent from '../FrameComponent'
const BannerColor = () => {
  const value = React.useContext(BannerToolContext)
  const [bannerColor, SetBannerColor] = useState(value.form2.value ? value.form2.value : '#414042')

  const handleChange = color => {
    SetBannerColor(color.hex)
    value.form2.value = color.hex
  }

  return (
    <div style={{display:'flex', flexDirection:'row'}}>
      <div  style={{display:'flex', flexDirection:'column' ,width:'25%', alignItems: 'center'}}>
        <div
        style={{fontWeight:'400', fontFamily:'Quicksand' ,fontSize:'20px', marginBottom: '16px', color:'#383F73',textAlign:'center' }}
          >
          Lütfen banner rengini seçiniz.
        </div>
        <BlockPicker
          width="250px"
          style={{ boxShadow: '0px 0px 20px 1px rgba(0, 0, 0, 0.05)', borderRadius: '20px' }}
          color={bannerColor}
          triangle="hide"
          onChange={handleChange}
        />
      </div>
      <div style={{display:'flex', justifyContent:'center', width:'75%', boxShadow:'0px 0px 20px 1px #0000000D'}}>
        <FrameComponent />
      </div>
    </div>
  )
}

export default BannerColor
